import PromiseLoader from "@/components/PromiseLoader/PromiseLoader";
import { FieldValidator } from "final-form";
// import "./DependingCalculationField.scss";
import ValidationPopover from "@/modules/abstract-ui/general/ValidationPopover/ValidationPopover";
import { Field } from "react-final-form";
import OnChange from "../Helpers/OnChange";
import { FV } from "../Validation/FormValidators";
import FormFieldValues from "./FormFieldValues";

interface DependingCalculationFieldProps<T, E> {
  name: string;
  dependingField: string;
  calulationPromise: (value: T) => Promise<{ value: E; data?: any }>;

  renderError?: (error: any, value: T, reload: () => void) => JSX.Element;
  renderLoading?: () => JSX.Element;
  renderValue: (value: E, data: any, reload: () => void) => JSX.Element;
  validate?: FieldValidator<E>;
  throttle?: number;
  renderEmpty?: () => JSX.Element;
}
const DependingCalculationField = <T, E>(
  props: DependingCalculationFieldProps<T, E>
) => {
  return (
    <Field name={props.name} validate={props.validate}>
      {({ input, meta }) => (
        <ValidationPopover {...FV.getValidation(meta)?.validation}>
          <FormFieldValues names={[props.dependingField]}>
            {([dependingFieldValue]) => (
              <OnChange
                value={dependingFieldValue}
                onChange={(val, prev) => {
                  if (!val) {
                    input?.onChange(null);
                  }
                }}
              >
                <>
                  {dependingFieldValue ? (
                    <PromiseLoader
                      throttle={props.throttle}
                      param={{
                        dependingFieldValue: dependingFieldValue,
                      }}
                      promise={async (param) =>
                        await props.calulationPromise(param.dependingFieldValue)
                      }
                      renderError={(err, reload) => {
                        input.onChange(null);

                        return props.renderError(
                          err,
                          dependingFieldValue,
                          reload
                        );
                      }}
                      renderLoading={props.renderLoading}
                      render={(data, reload) => {
                        input.onChange(data.value);
                        return props.renderValue(data.value, data.data, reload);
                      }}
                    />
                  ) : (
                    props.renderEmpty?.()
                  )}
                </>
              </OnChange>
            )}
          </FormFieldValues>
        </ValidationPopover>
      )}
    </Field>
  );
};

export default DependingCalculationField;
